import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

// Components
import { NavbarHeader } from "./components/NavbarHeader";
import { FooterSection } from "./components/FooterSection";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Coaching from "./pages/Coaching";
import FreeResources from "./pages/FreeResources";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";
import StartHere from "./pages/StartHere";
import { PrivacyPolicy, TermsConditions, RefundPolicy } from "./pages/LegalPages";

// Scroll restoration helper
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App flex flex-col min-h-screen bg-obsidian text-slate-100 selection:bg-gold selection:text-obsidian">
      <BrowserRouter>
        <ScrollToTop />
        <NavbarHeader />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/coaching" element={<Coaching />} />
            <Route path="/free-resources" element={<FreeResources />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/start-here" element={<StartHere />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
          </Routes>
        </main>

        <FooterSection />
        <Toaster position="top-right" richColors theme="dark" closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
